/**
 * @generated SignedSource<<83b0e5428a6a2a436fffa6ab4af716e8>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type InterviewStatus = "accepted" | "deleted" | "rejected" | "requested";
export type JobApplicationStatus = "deleted" | "freelancer_not_interested" | "hired" | "interview" | "job_application_draft" | "job_application_invited" | "job_application_sent" | "job_viewed" | "offer" | "potential" | "rejected" | "screening_completed" | "screening_rejected" | "screening_requested" | "screening_started";
import { FragmentRefs } from "relay-runtime";
export type freelancer_useIsRejectabaleJobApplication$data = {
  readonly latestInterview: {
    readonly status: InterviewStatus | null | undefined;
  } | null | undefined;
  readonly status: JobApplicationStatus;
  readonly " $fragmentType": "freelancer_useIsRejectabaleJobApplication";
};
export type freelancer_useIsRejectabaleJobApplication$key = {
  readonly " $data"?: freelancer_useIsRejectabaleJobApplication$data;
  readonly " $fragmentSpreads": FragmentRefs<"freelancer_useIsRejectabaleJobApplication">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "freelancer_useIsRejectabaleJobApplication",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "Interview",
      "kind": "LinkedField",
      "name": "latestInterview",
      "plural": false,
      "selections": [
        (v0/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "type": "JobApplication",
  "abstractKey": null
};
})();

(node as any).hash = "1188990d09cec2a40ba65b8a3a047381";

export default node;
